import "./styles.scss";

import classnames from "classnames";
import { Trans, useTranslation } from "react-i18next";

import { ReactComponent as CheckmarkIcon } from "assets/icons/new/check.svg";

const mainClass =
  "new-website-content__choose-plan__subscription-plan__header__item__billed-buttons";

const billingOptions = [
  { value: "monthly", label: "Monthly (monthly payment)" },
  { value: "yearly", label: "Yearly (monthly payment)" },
];

const BilledButtons = ({ value, onChange }) => {
  const { t } = useTranslation();

  return (
    <div className={mainClass}>
      <p>{t("Billing method and plan")}</p>
      {billingOptions.map((option) => (
        <button
          key={option.value}
          type="button"
          className={classnames({ active: value === option.value })}
          aria-pressed={value === option.value}
          onClick={() => onChange(option.value)}
        >
          <i aria-hidden="true">
            <CheckmarkIcon />
          </i>
          <span>
            <Trans i18nKey={option.label} components={{ strong: <strong /> }} />
          </span>
        </button>
      ))}
    </div>
  );
};

export default BilledButtons;